module.exports = __webpack_public_path__ + "media/images/app_icons/android-icon-144x144-d457ed85acc710a9ea9fc3059b2504cb.png";